import { CheckCircle, Circle } from "@phosphor-icons/react";
import { MatchingProfileFields } from "@/components/matching/MatchingProfileEditor";
import type { TherapistMatchingProfile } from "@/types/matching";
import { cn } from "@/lib/utils";

// Controlled by the onboarding wizard: the parent owns the profile state and
// persists it via the shared "Sačuvaj i nastavi" button, so this step has no
// save button of its own. The checklist mirrors `isMatchingProfileReady`.
export function MatchingStep({
  value,
  onChange,
}: {
  value: TherapistMatchingProfile;
  onChange: (next: TherapistMatchingProfile) => void;
}) {
  const required = [
    { label: "Bar jedna glavna oblast rada", done: value.primaryProblemTags.length > 0 },
    { label: "Bar jedna grupa klijenata (populacija)", done: value.populationTags.length > 0 },
  ];
  return (
    <div className="space-y-5">
      <ul className="flex flex-wrap gap-x-5 gap-y-1.5 text-sm">
        {required.map((r) => (
          <li key={r.label} className={cn("flex items-center gap-1.5", r.done ? "text-primary" : "text-muted-foreground")}>
            {r.done ? <CheckCircle weight="fill" className="size-4" /> : <Circle className="size-4" />}
            {r.label}
          </li>
        ))}
      </ul>
      <MatchingProfileFields profile={value} onChange={onChange} />
    </div>
  );
}
